import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { Truck, ShoppingBag, UtensilsCrossed } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { OrderType } from '../types'

interface OrderTypeBadgeProps {
  type: OrderType
  className?: string
  showIcon?: boolean
}

const typeConfig: Record<OrderType, {
  icon: typeof Truck
  bgColor: string
  textColor: string
}> = {
  delivery: {
    icon: Truck,
    bgColor: 'bg-blue-500/15',
    textColor: 'text-blue-400'
  },
  pickup: {
    icon: ShoppingBag,
    bgColor: 'bg-emerald-500/15',
    textColor: 'text-emerald-400'
  },
  dineIn: {
    icon: UtensilsCrossed,
    bgColor: 'bg-purple-500/15',
    textColor: 'text-purple-400'
  },
}

export function OrderTypeBadge({ type, className, showIcon = true }: OrderTypeBadgeProps) {
  const { t } = useTranslation('orders')
  const config = typeConfig[type]
  const Icon = config.icon

  return (
    <Badge
      variant="outline"
      className={cn(
        config.bgColor,
        config.textColor,
        'border-transparent font-medium',
        className
      )}
    >
      {showIcon && <Icon className="w-3 h-3 me-1" />}
      {t(`orderType.${type}`)}
    </Badge>
  )
}
